import { Button } from "../Button"
import { RiPhoneLine, RiMailLine } from "@remixicon/react"

export function CharlestonCTA() {
  return (
    <section aria-labelledby="cta-title" id="contact" className="mx-auto max-w-7xl px-4 scroll-my-24">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#003566] via-[#001d3d] to-[#000814] p-8 md:p-16 shadow-2xl">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#ffc300]/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#ffc300]/5 rounded-full blur-3xl" />

        <div className="relative grid items-center gap-12 lg:grid-cols-2">
          <div>
            <h2
              id="cta-title"
              className="text-4xl font-semibold tracking-tighter text-balance text-white md:text-5xl"
            >
              Ready to Grow Your Business?
            </h2>
            <p className="mt-4 text-lg text-gray-300 leading-relaxed">
              Let's schedule a free consultation to discuss your goals. We'll create a custom digital marketing strategy tailored to your business.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                href="https://airtable.com/appR9wgPnwfYKJA5f/pagEhOnZkUUuOZskP/form"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center text-md px-8 py-3 rounded-md bg-gradient-to-b from-[#06b6d4] to-[#0ea5e9] text-white font-medium shadow-[0_0_0_2px_rgba(14,165,233,0.1),0_0_20px_0_rgba(14,165,233,0.4)] transition-all duration-200 hover:shadow-[0_0_0_2px_rgba(14,165,233,0.15),0_0_28px_0_rgba(14,165,233,0.6)] hover:scale-105"
              >
                Schedule Free Consultation
              </a>
              <Button asChild className="text-md border-white/20 bg-white/10 text-white hover:bg-white/20 backdrop-blur-sm" variant="secondary">
                <a href="#services">View Our Services</a>
              </Button>
            </div>

            <div className="mt-12 space-y-4">
              <div className="flex items-center gap-3 text-gray-300">
                <div className="flex items-center justify-center rounded-full bg-white/10 p-2">
                  <RiPhoneLine className="size-5 text-white" />
                </div>
                <div>
                  <p className="text-sm text-gray-400">Call us</p>
                  <a href="tel:+18435551234" className="text-white font-medium hover:text-[#ffc300] transition-colors">
                    (843) 555-1234
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-3 text-gray-300">
                <div className="flex items-center justify-center rounded-full bg-white/10 p-2">
                  <RiMailLine className="size-5 text-white" />
                </div>
                <div>
                  <p className="text-sm text-gray-400">Email us</p>
                  <a href="mailto:contact@marketieragency.com" className="text-white font-medium hover:text-[#ffc300] transition-colors">
                    contact@marketieragency.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20 p-8 shadow-xl">
              <h3 className="text-2xl font-semibold text-white mb-6">What You'll Get</h3>
              <ul className="space-y-4">
                {[
                  "Free marketing audit of your current presence",
                  "Custom strategy designed for your market",
                  "Transparent pricing with no hidden fees",
                  "Direct access to our team of experts",
                  "Monthly reporting and strategy calls",
                  "Flexible contracts tailored to your needs",
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className="mt-1 flex-shrink-0 w-5 h-5 rounded-full bg-[#ffc300] flex items-center justify-center">
                      <svg className="w-3 h-3 text-[#003566]" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-gray-200">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CharlestonCTA
